class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

resetQuantityInput(id) {
  const input =
    document.getElementById(`Quantity-${id}`) ||
    document.getElementById(`Drawer-quantity-${id}`);

  if (!input) return;

  const newQty = parseInt(input.getAttribute('data-limit'), 10);

  input.value = newQty;

  this.isEnterPressed = false;

  const line = input.dataset.index
    ? parseInt(input.dataset.index, 10)
    : Array.from(document.querySelectorAll('[id^="Quantity-"]')).indexOf(input) + 1;

  this.updateQuantity(line, newQty, input);
  if (window.location.href.includes('cart')) setTimeout(() => window.location.reload(), 800);
}

  // setValidity(event, index, message) {
  //   event.target.setCustomValidity(message);
  //   event.target.reportValidity();
  //   this.resetQuantityInput(index);
  //   console.log('change',index);
  //   event.target.select();
  // }
  setValidity(event, index, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${index}`) ||
      document.getElementById(`CartDrawer-LineItemError-${index}`);

    // Reset input to previous valid value
    const input =
      document.getElementById(`Quantity-${index}`) ||
      document.getElementById(`Drawer-quantity-${index}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;

    // Show inline message
    if (lineItemError && lineItemError.querySelector('.cart-item__error-text')) {
      lineItemError.querySelector('.cart-item__error-text').textContent = message;
      lineItemError.classList.remove('hidden');
    } else {
      console.warn(`Missing inline error container for line ${index}`);
    }

    // Hide default popup
    event.target.setCustomValidity('');
    //this.resetQuantityInput(index);
  }


  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    const limit = parseInt(event.target.dataset.limit);
    let message = '';

    const isChinese = window.location.pathname.includes('/zh/');

    if (inputValue < parseInt(event.target.dataset.min)) {
      message = isChinese
        ? `最少购买数量为 ${event.target.dataset.min}。`
        : `Minimum quantity is ${event.target.dataset.min}.`;
    } else if (limit > 0 && inputValue > limit) {
      message = isChinese
        ? `本商品限定每单每种类的购买上限为${limit}个。`
        : `There is a limit of ${limit} per customer per order.`;
    } else if (event.target.max && inputValue > parseInt(event.target.max)) {
      message = isChinese
        ? `库存上限为 ${event.target.max}。`
        : `Stock limit is ${event.target.max}.`;
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = isChinese
        ? `数量必须为 ${event.target.step} 的倍数。`
        : `Quantity must be in multiples of ${event.target.step}.`;
    }

    // if (message) {
    //   this.setValidity(event, index, message);
    // } else {
    //   event.target.setCustomValidity('');
    //   event.target.reportValidity();
    //   this.updateQuantity(
    //     index,
    //     inputValue,
    //     event,
    //     document.activeElement.getAttribute('name'),
    //     event.target.dataset.quantityVariantId
    //   );
    // }
    if (message) {
      this.setValidity(event, index, message);
      console.log("error1");
    } else {
      console.log("error2");
      // Clear inline error when fixed
      const lineItemError =
        document.getElementById(`Line-item-error-${index}`) ||
        document.getElementById(`CartDrawer-LineItemError-${index}`);
      if (lineItemError) {
        lineItemError.classList.add('hidden');
        lineItemError.querySelector('.cart-item__error-text').textContent = '';
      }

      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }


  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            
            // Reset to previous value
            quantityElement.value = quantityElement.getAttribute('value');

            // Show error message either inline or in live region
            const lineItemError =
              document.getElementById(`Line-item-error-${line}`) ||
              document.getElementById(`CartDrawer-LineItemError-${line}`);

            let errorMessage = '';
            if (typeof parsedState.errors === 'string') {
              // Shopify sometimes returns a generic string message
              errorMessage = parsedState.errors;
            } else if (parsedState.errors.base) {
              // Or an object like { base: ["You can only purchase 3 of this item"] }
              errorMessage = parsedState.errors.base.join(', ');
            } else {
              errorMessage = window.cartStrings.error;
            }

            if (lineItemError && lineItemError.querySelector('.cart-item__error-text')) {
              lineItemError.querySelector('.cart-item__error-text').textContent = errorMessage;
              lineItemError.classList.remove('hidden');
            } else {
              // fallback to live region for screen readers
              this.updateLiveRegions(line, errorMessage);
            }

            return;
          }


          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        console.log("finished loading");
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
